import React from "react";
import { getPartialFormData } from "../../services/pendingService";
import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { Row, Col } from "react-bootstrap";
import { checkPermissionStatus, generateMaskedPII } from "helpers/utils";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import Dropdown from "react-bootstrap/Dropdown";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import threedots from "../../assets/images/icon/three-dots.svg";
import { downloadCSVReportPendingJob } from "helpers/backend_helper";
import { CSVLink } from "react-csv";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { useTranslation } from "react-i18next";
import RemotePagination from "components/Common/RemotePagination";
import SearchBar from "components/Common/Searchbar";

function PartialApplication(props) {
  const { t } = useTranslation();
  const [dataList, setDataList] = useState([]);
  const [csvData, setCSVData] = useState([]);
  const [query, setQuery] = useState("");

  const [totalCounts, setTotalCounts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);

  const history = useHistory();
  // Fetch Listing Data
  useEffect(() => {
    getApplicantData(1, 10);
    document.title = "NeuroTal - Partal Form";
  }, []);

  const handleCSVDownload = async e => {
    e.preventDefault();
    let data = {};
    let selectedIds = [];
    let allData = dataList?.map(el => {
      if (el?.checked) {
        selectedIds.push(el?.appl_id);
      }
      return el;
    });
    if (selectedIds?.length > 0) {
      data = {
        type: "selective",
        candidateIds: selectedIds?.join(","),
        listType: "pending",
      };
    } else {
      data = {
        type: "All",
        candidateIds: "",
        listType: "pending",
      };
    }

    try {
      await downloadCSVReportPendingJob(data)
        .then(res => {
          let csvData = res?.data?.map(item => ({
            ...item,
            email_id: generateMaskedPII(item?.email_id),
            mobile: generateMaskedPII(item?.mobile, 2),
          }));
          setCSVData(csvData);
          setTimeout(() => {
            let element = document.getElementById("downloadCSV");
            element.click();
          }, 1000);
        })
        .catch(err => {
          console.log(err);
          return [];
        });
    } catch (err) {
      return [];
    }
  };

  const columns = [
    {
      dataField: "appl_id",
      text: t(`Partial Form.Application No`),
      classes: "total",
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const formattedDate =
          row.appl_id +
          "/" +
          (applyDate.getMonth() + 1) +
          "" +
          applyDate.getFullYear();
        return (
          <div className="date-tabel">
            <input
              id={`checkbox-${row?.appl_id}`} // Add a unique ID
              defaultChecked={row?.checked || false}
              onClick={e => handleCheck(e, row?.appl_id)}
              type="checkbox"
              className="d-none"
            />
            <label htmlFor={`checkbox-${row?.appl_id}`}>{formattedDate}</label>
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: t(`Partial Form.Name`),
      classes: "application-name ",
      formatter: (cell, row) => (
        <span
          className="clickable-link"
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.push(`/candidate_consolidate/view-details/${row.appl_id}`);
          }}
        >
          {cell}
        </span>
      ),
    },
    {
      dataField: "email_id",
      text: t(`Partial Form.Email Id`),
      classes: "application-email ",
      formatter: (cell, row) => <>{generateMaskedPII(row?.email_id)}</>,
    },
    {
      dataField: "mobile",
      text: t(`Partial Form.Mobile No`),
      classes: "application-normal",
      formatter: (cell, row) => <>{generateMaskedPII(row?.mobile, 2)}</>,
    },
    {
      dataField: "job_user.master_reference_table.gender",
      text: t(`Partial Form.Gender`),
      classes: "application-normal",
      formatter: (cell, row) => {
        return t(`Gender.${cell}`);
      },
    },
    // {
    //   dataField: "job_user.age",
    //   text: "Age",
    //   classes: "application-normal",
    // },
    {
      dataField: "master_reference_table.highest_qualification",
      text: t(`Partial Form.Education`),
      classes: "application-normal education",
    },
    {
      dataField: "job_user.total_experience",
      text: t(`Partial Form.Total Exp`),
      classes: "application-normal application-step exp",
      headerClasses: "text-center application-step exp",
    },
    {
      dataField: "vacancy.title",
      text: t(`Partial Form.Job Role`),
      classes: "application-normal",
    },
    {
      dataField: "master_city.city",
      text: t(`Partial Form.City`),
      classes: "application-normal",
    },
    {
      dataField: "step",
      text: t(`Partial Form.Application Step`),
      classes: "application-normal application-step",
      headerClasses: "text-center application-step",
    },
    {
      dataField: "Actions",
      text: t(`Partial Form.Actions`),
      classes: "total text-center",
      headerClasses: "text-center",
      formatter: (cell, row) => {
        let appl_id = row?.appl_id;
        return (
          <div className="action-application">
            <div className="action-one filter">
              <Dropdown>
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  aria-label="More actions" // Accessible label for the button
                >
                  <img src={threedots} alt="More actions" />{" "}
                  {/* Add descriptive alt text */}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("pending-list", "view")}
                    href={"candidate_consolidate/view-details/" + appl_id}
                  >
                    {t(`Partial Form.View Details`)}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        );
      },
    },
    // Add more columns as needed
  ];

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  const getApplicantData = async (
    current = currentPage,
    size = sizePerPage,
    query_text = query
  ) => {
    await getPartialFormData({
      page: current || currentPage,
      pageSize: size || sizePerPage,
      queryText: query_text || query,
    })
      .then(res => {
        setDataList(res?.data?.data || []);
        setTotalCounts(res.data?.total_counts);
      })
      .catch(err => {
        let errorMsg = JSON.stringify(err?.response?.message);
        toast.error(errorMsg || t(`Partial Form.Something Went Wrong`));
      });
  };

  

  const handleTableChange = (type, { page, sizePerPage }) => {
    setTimeout(() => {
      setCurrentPage(page);
      setSizePerPage(sizePerPage);
      getApplicantData(page, sizePerPage, query);
    }, 500);
  };

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleSearch = () => {
    getApplicantData(1, 10);
    setCurrentPage(1);
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  if (!checkPermissionStatus("feedbacks", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center"> {t(`Partial Form.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <div className="pending-list-page feedbacks  departmentpage">
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            // aria-labelledby="pills-home-tab"
          >
            <div className="joblist-container create-vacancy">
              <Row className="mb-2 align-items-center">
                <Col lg="6" md="6" className="Joblist-column">
                  <Link to="/dashboard">
                    <h5 className="text-uppercase heading-one">
                      <img src={arrow_btn} alt="arrow_btn" />
                      {t(`Partial Form.Partial Form`)}
                    </h5>
                  </Link>
                </Col>
              </Row>
            </div>

            <div className="outerTab-box-wrapper applicationcard-table partial-application">
              <div className="tabel-application table-responsive white-space-row  pb-3">
                <div className="table-data-search">
                  <div className="total-record">
                    <h5>
                      {t(`Partial Form.Total Records`)}:{" "}
                      <span>{totalCounts || 0}</span>
                    </h5>
                  </div>
                  <div className="total-serachbar">
                    <SearchBar
                      onSearch={handleSearch}
                      placeholder={t(`Partial Form.Search By`)}
                      title={t(`Partial Form.Search By`)}
                      query={query}
                      setQuery={setQuery}
                    />

                    {checkPermissionStatus("partial-form", "downloadcsv") && (
                      <div className="take-text">
                        <CSVLink
                          data={csvData}
                          headers={[
                            {
                              key: "appl_id",
                              label: t(`Partial Form.Application ID`),
                            },
                            {
                              key: "name",
                              label: t(`Partial Form.Name`),
                            },
                            {
                              key: "mobile",
                              label: t(`Partial Form.Mobile No`),
                            },
                            {
                              key: "email_id",
                              label: t(`Partial Form.Email Id`),
                            },
                            {
                              key: "createdAt",
                              label: t(`Partial Form.Created At`),
                            },
                            {
                              key: "f2f_address",
                              label: t(`Partial Form.Address`),
                            },
                            {
                              key: "step",
                              label: t(`Partial Form.Application Step`),
                            },
                          ]}
                          filename={`PendingApplicationList.csv`}
                          id="downloadCSV"
                        >
                          <Button
                            color="info"
                            onClick={e => handleCSVDownload(e)}
                            outline
                          >
                            <img src={dowanload_csv} alt="Download" />
                            {t(`Partial Form.Download CSV`)}
                          </Button>
                        </CSVLink>
                      </div>
                    )}

                    <div className="tale-text right-panel">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip={t(`Partial Form.Scroll Left`)}
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip={t(`Partial Form.Scroll Right`)}
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                    </div>
                  </div>
                </div>

                <div className="timeto-hire-card userlist pendiglist-cardss">
                  <div className="table-custome-class range-custome">
                    <>
                      <div className="scroll-container">
                        <div className="table-pending-list">
                          {dataList?.length > 0 && (
                            <div
                              className="table-wrapper"
                              ref={tableWrapperRef}
                            >
                              <RemotePagination
                                keyField="appl_id"
                                data={dataList}
                                columns={columns}
                                page={currentPage}
                                sizePerPage={sizePerPage}
                                totalSize={totalCounts}
                                onTableChange={handleTableChange}
                                rowClasses={rowClasses}
                              />
                            </div>
                          )}

                          {dataList?.length === 0 && (
                            <>
                              <div className="no-data data-available">
                                <img
                                  src="../../img/data-not-available.png"
                                  alt="data not availble"
                                />
                                <h3> {t(`Partial Form.No Item Found`)}</h3>
                                <p>
                                  {t(
                                    `Partial Form.Sorry, we could not find any`
                                  )}
                                  <br /> {t(`Partial Form.Item to show here`)}
                                </p>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PartialApplication;
